import React from 'react';
import logo from '@/assets/images/logo.png';
import '../index.scss';

function PrivateEN() {
    return (
        <div className='PrivacyPolicy'>
            <div className="header">
                <a href="https://xmp.mobvista.com/login"><img src={logo} width="60" alt='logo' /></a>
            </div>
            <div className={"container"}>
                <div className={"content"}>
                    <h2>Privacy Policy</h2>
                    <p>&nbsp;</p>
                    <p>【17/Oct】，2024</p>
                    <p>
                        XMP entities (can be viewed
                        <a href="https://xmp.mobvista.com/official/one-pager/XMP_entities_list.pdf">HERE</a>,
                        collectively, “XMP”, or “we”, “us”, “our”) provide this Privacy Policy to explain how
                        we collect, use, and share information. For the purposes of European data protection
                        laws, XMP is the data controller of your personal information. This Privacy Policy
                        (“Policy”) covers XMP’s handling of two types of information:
                    </p>
                    <ol>
                        <li>
                            Information we receive when we provide our XMP’s platform, software,
                            technology, tools or any other service (“XMP Services” or “Services”).
                        </li>
                        <li>
                            Information we receive through our website at <a href="https://xmp.mobvista.com">
                            https://xmp.mobvista.com</a> or any other website on which this Policy is posted,
                            as well as information we get through other corporate services and web portals we
                            make available to clients and BusinessnPartners (“XMP Sites”, “Website”, “Site”)
                            from XMP Sites visitors (“Visitors”, “you” or “your”).
                        </li>
                    </ol>
                    <p>
                        This Policy is subject to any service agreement between XMP and you. By using the
                        XMP Services or XMP Sites, you acknowledge that you have read, understood and
                        agreed to this Policy. Please review this Policy before using the XMP Services or the
                        XMP Sites.
                    </p>
                    <p>
                        We evaluate this Policy and procedures to implement improvements and refinements
                        from time to time. If we make material changes to this Policy we will notify you by
                        means of a prominent notice on XMP Sites prior to the change becoming effective.
                    </p>
                    <p>
                        Data protection and ensuring our business partners’ and your trust is at the core of
                        XMP’s business principles. Accordingly, being compliance with applicable data
                        protection laws is our top priority and this Policy is updated to be compliance with the
                        applicable data protection laws, including EU General Data Protection Regulation
                        (“GDPR”), the Children’s Online Privacy Protection Act (“COPPA”), the California
                        Customer Privacy Act (“CCPA”) , the Brazilian General Data Protection Law (Lei
                        Geral de Proteção de Dados Pessoais) (“LGPD”) and the Chinese Personal
                        Information Protection Law (“Chinese PIPL”).
                    </p>
                    <p>
                        For the purpose of this Policy, “Processor” means an “entrusted handler” under the PIPL, a “processor” under the GDPR, VCDPA, and a “service provider” under the
                        CCPA. “Controller” means a “personal information handler” under the
                        PIPL, a
                        “controller” under the GDPR, VCDPA, and a “business” under the CCPA.
                    </p>
                    <p>&nbsp;</p>
                    <h3>Privacy Policy of the XMP Services</h3>
                    <p>&nbsp;</p>
                    <h4>1. Introduction</h4>
                    <p>
                        This Policy applies to XMP’s information collection and use while: (i) Business
                        Partners use or interact with XMP Services; (ii) End User (“User”, “you” or “your”)
                        interacts with platforms, applications, websites or other services provided by XMP’s
                        Business Partners.
                    </p>
                    <p>
                        The XMP Services provide a one-stop platform which integrates different channels
                        that enable Business Partners to manages its accounts with just several clicks. For the
                        purpose of the abovementioned services, Business Partners may entrust us to collect
                        and use the personal information about Users. As we provide XMP Services for our
                        Business Partners, we may also process information of the contacts of such Business
                        Partners.<span className="Apple-converted-space"
                        >&nbsp;</span
                        >
                    </p>
                    <p>
                        Except as expressly stated in this Policy, XMP acts as a Processor when processing
                        Users' personal information in accordance with the purpose and method entrusted by
                        the Business Partners. Our Business Partners act as a Controller who independently
                        determine the purpose and method of processing such information.
                    </p>
                    <p>
                        The XMP Services may link to third party websites, Apps or other third party content.
                        Please note that we cannot control the treatment of a User’s information by such third
                        parties, and that the privacy practices of third parties likely differ from those
                        described in this Policsy.
                    </p>
                    <p>&nbsp;</p>
                    <h4>
                        2. How And What We Collect From User
                        <span className="Apple-converted-space">&nbsp;</span>
                    </h4>
                    <p>
                        We collect information from our Business Partners: (i) our Business Partners may
                        transmit your information to us;(ii) when we access a third-party platform based on
                        the authorization and/or entrustment of our Business Partners, the third-party platform
                        may transmit your information to us.
                    </p>
                    <p>
                        To provide XMP Services to our Business Partners, we collect contact information
                        through them. We have entrusted our Business Partners to obtain valid consent from
                        their contacts on our behalf for the collection and use of information as a Processor.
                    </p>
                    <p>
                        Regarding the collection of the aforementioned information and the acquisition of
                        valid consent, we have required our Business Partners in our cooperation agreement
                        to commit to and guarantee the legality of the source of information, and to inform
                        you about the specifics of our processing of information in accordance with applicable
                        law, and to obtain valid consent from you (and, if necessary, separate consent as
                        required by applicable laws), ensuring that you can withdraw such consent at any
                        time.<span className="Apple-converted-space"
                        >&nbsp;</span
                        >
                    </p>
                    <p>&nbsp;</p>
                    <h4>
                        3. Information We May Collect From User
                        <span className="Apple-converted-space">&nbsp;</span>
                    </h4>
                    <p>
                        (i) When we provide XMP Services to our Business Partners, we may collect such information:
                    </p>
                    <ol style={{ listStyleType: 'lower-alpha' }}>
                        <li>
                            The information transmitted to us by our Business Partners: IMEI, IDFA, IDFV,
                            Android ID, GAID, OAID, MAC address; IP; advertising data, such as spend, display,
                            clicks, revenues, retention and so on.
                        </li>
                        <li>
                            The information transmitted to us by third party platforms to which we have
                            accessed by the authorization and/or entrustment of our Business Partners: IMEI,
                            IDFA, IDFV, Android ID, GAID, OAID, MAC address; IP; advertising data, such as
                            spend, display, clicks, revenues, retention and so on.
                        </li>
                    </ol>
                    <p>
                        (ii) As we provide XMP Services for our Business Partners, we may collect name, job
                        title, email address, contact address and the account name and password used to
                        access XMP Services, IP address of the individuals using XMP services on behalf of
                        such Business Partners.
                    </p>
                    <p>&nbsp;</p>
                    <h4>
                        4. About Sensitive Personal Information
                        <span className="Apple-converted-space">&nbsp;</span>
                    </h4>
                    <p>
                        Sensitive Personal Information refers to information that, once leaked or illegally used,
                        will easily lead to infringement of the human dignity or harm to the personal or
                        property safety of a natural person. The scope of sensitive personal information may
                        vary pursuant to different applicable data protection law.
                    </p>
                    <p>
                        We will not collect your sensitive personal information without your consent. Our
                        Business Partners will transmit or authorize us to process your sensitive personal
                        information after notifying you the necessity of processing your sensitive personal
                        information and the impact of your rights and interests with your consent.
                    </p>
                    <p>&nbsp;</p>
                    <h4>
                        5. How We Use Users’ Personal Information
                        <span className="Apple-converted-space">&nbsp;</span>
                    </h4>
                    <p>
                        We use your information for the following purposes:
                    </p>
                    <table>
                        <thead>
                            <tr colspan="2">
                                <th colspan="2">Types of Personal Information</th>
                                <th>Usage</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>User Information</td>
                                <td>
                                    All types of personal information as described in Article 3 (1) of this Policy
                                </td>
                                <td>
                                    As a Processer, we analyze and calculate advertising
                                    information sourced from our Business Partners and
                                    third-party platforms to assist our Business Partners in
                                    understanding the effectiveness of their advertising
                                    campaigns so that they can further optimize their
                                    advertising strategies.
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Business Representative Information
                                </td>
                                <td>
                                    All types of personal information as described in Article 3 (2) of this Policy
                                </td>
                                <td>
                                    As a Processer, we use information of Users who are
                                    representing our Business Partners to use XMP
                                    Services for purpose of business contact and direct
                                    marking (e.g. sending marketing emails), as well as for
                                    identity verification when they log in to the XMP
                                    Services.
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Sensitive Personal Information
                                </td>
                                <td>/</td>
                                <td>
                                    We will not collect your sensitive personal
                                    information without your consent. Our Business
                                    Partners will transmit or authorize us to process your
                                    sensitive personal information after notifying you the
                                    necessity of processing your sensitive personal
                                    information and the impact of your rights and interests
                                    with your consent.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>&nbsp;</p>
                    <h4>
                        6. The Legal Basis for Our Processing of Users' Personal Information
                        <span className="Apple-converted-space">&nbsp;</span>
                    </h4>
                    <p>
                        Where required by applicable laws, we have contractually agreed that our Business
                        Partners will obtain consent of a user or their employees for and on our behalf for our
                        processing of his/her personal information described in this Policy. A data subject can
                        withdraw their consent at any time.
                    </p>
                    <p>&nbsp;</p>
                    <h4>
                        7. How We Share, Entrust the Processing, Transfer, Disclose And Transmit Users’ Personal Information
                        <span className="Apple-converted-space">&nbsp;</span>
                    </h4>
                    <p>(i) Sharing</p>
                    <p>
                        We will not disclose User’s personal information to any third party without User’s consent.
                    </p>
                    <p>(ii) Entrusted Processing</p>
                    <table>
                        <thead>
                            <tr>
                                <td>Type of Third Parties</td>
                                <td>Information of Third Parties</td>
                                <td>Type of Information</td>
                                <td>Processing Purpose and Processing Method</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Cloud Service Providers</td>
                                <td>
                                    <a href="https://xmp.mobvista.com/official/one-pager/Cloud+Technology+Service+Providers.pdf">
                                    See the cloud service providers</a>
                                </td>
                                <td>Including all types of personal information described in Article 3 of this Policy.</td>
                                <td>
                                    a.For purpose of data storage.<br />
                                    b.For responding to data calculating and storage requests;<br />
                                    c.For ensuring systems and processes work properly and securely;
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>
                        Except as expressly stated in this Policy, we do not entrust other third parties with the
                        processing of Users' personal information.
                    </p>
                    <p>(iii) Assignment:</p>
                    <p>
                        We will not transfer the user's personal information to any company, organization or
                        individual, except in the following cases:
                    </p>
                    <ol style={{ listStyleType: 'lower-alpha' }}>
                        <li>
                            We inform the user in advance of the type, purpose, manner and scope of the
                            transfer of personal information and obtain the user's separate consent;
                        </li>
                        <li>
                            In the event of a merger, separation, dissolution, bankruptcy, etc. that requires the
                            transfer of personal information, we will inform the user of the name and contact
                            information of the recipient and request the recipient to continue to perform the
                            obligations of the processor of personal information. If the recipient changes the
                            original purpose or method of processing, we will ask the recipient to obtain the
                            user's consent again.
                        </li>
                    </ol>
                    <p>(iv) Public Disclosure</p>
                    <p>
                        We do not publicly disclose the personal information of users, except in the following
                        cases:
                    </p>
                    <ol style={{ listStyleType: 'lower-alpha' }}>
                        <li>
                            After informing the user of the type, purpose, manner and scope of the personal
                            information to be publicly disclosed and obtaining the user's separate consent;
                        </li>
                        <li>
                            When compelled by laws, regulations, legal proceedings, litigation or government
                            authorities.
                        </li>
                    </ol>
                    <p>(v) International Transfers</p>
                    <p>
                        When you are located in the European Economic Area (“EEA”), information
                        collected about you will be transferred to recipients in countries located outside the
                        EEA, including in countries which may not be decided by the European Commission
                        that it provides an adequate level of protection to personal information. We have
                        followed requirements as set out in applicable law to provide adequate protection to
                        your information.
                    </p>
                    <p>
                        XMP has entered into EU standard contractual clauses (“Model Contracts”) for
                        intra-group transfers of personal information to its affiliates. You can request a copy
                        of these Model Contracts by contact us at <a href="privacy@mobvista.com">privacy@mobvista.com</a>.
                    </p>
                    <p>&nbsp;</p>
                    <h4>
                        8. Your Data Rights
                        <span className="Apple-converted-space">&nbsp;</span>
                    </h4>
                    <p>
                        You have the right to access, modify, correct or delete any personal data which we
                        may have collected. To exercise your right, please contact us at
                        <a href="privacy@mobvista.com">privacy@mobvista.com</a>.
                    </p>
                    <p>
                        If you are in the EEA, you have a right to (subject to a limited number of exceptions
                        as permitted by GDPR):
                    </p>
                    <p>
                        (i)To request access to and rectification or erasure of your personal information;
                    </p>
                    <p>
                        (ii)To obtain restriction of processing or to object to processing of your personal information;
                    </p>
                    <p>
                        (iii)To ask for a copy of your personal information to be provided to them, or a third party, in a digital format.
                    </p>
                    <p>
                        You also have the right to lodge a complaint about the processing of your personal information with your local data protection authority in the EEA.
                    </p>
                    <p>
                        If you are residents of the State of California in the United States, you can request the
                        following information about how we have collected and used your personal
                        information during the past 12 months:
                    </p>
                    <p>
                        (i)The categories of personal information we have collected.
                    </p>
                    <p>
                        (ii)The categories of sources from which we collected the personal information.
                    </p>
                    <p>
                        (iii)The business or commercial purpose for collecting, selling or sharing personal information.
                    </p>
                    <p>
                        (iv)The categories of third parties with whom we disclose the personal information.
                    </p>
                    <p>
                        (v)The categories of personal information that we sold, shared or disclosed for a business purpose.
                    </p>
                    <p>
                        (vi)The categories of third parties to whom the personal information was sold, shared or disclosed for a business purpose.
                    </p>
                    <p>
                        (vii)Access. You can request a copy of your personal information that we have collected during the past 12 months.
                    </p>
                    <p>
                        (viii)You can ask us to delete your personal information that we have collected.
                    </p>
                    <p>
                        (ix)You can ask us to correct inaccuracies of your personal information.
                    </p>
                    <p>
                        You are entitled to exercise the rights described above free from discrimination as
                        prohibited by the CCPA. You may (i) submit requests to exercise your California
                        privacy rights described above by contact us at <a href="privacy@mobvista.com">
                        privacy@mobvista.com</a> or send a written document to the following address:
                        Legal Department, Room 4312, No. 222-3 Xingmin Road, Tianhe District, Guangzhou City,
                        Guangdong Province, China; (ii)opt out of selling or sharing of your data by clicking
                        on the following link: <a href="https://xmp.mobvista.com/official/one-pager/do-not-sell-my-data-XMP.pdf">
                        DO NOT SELL OR SHARE MY DATA</a> and (iii) submit requests to restrict  the use of your sensitive personal
                        information by contact us at <a href="privacy@mobvista.com">privacy@mobvista.com</a>.
                    </p>
                    <p>
                        For clarification, we do not sell or share your personal information as defined by the CCPA.
                    </p>
                    <p>
                        If you are a resident of the State of Virginia in the United States, effective January 1,
                        2023, or if you are a resident of the State of Colorado or Connecticut in the United
                        States, effective July 1, 2023, you may exercise the following personal information
                        rights with us.
                    </p>
                    <p>
                        (i)To confirm whether we are processing your personal information and to access that personal information;
                    </p>
                    <p>
                        (ii)To correct any inaccuracies in your personal information;
                    </p>
                    <p>
                        (iii)To delete your personal information;
                    </p>
                    <p>
                        (iv)To obtain a copy of the personal information you have provided to us; and
                    </p>
                    <p>
                        (v)To request a refusal to allow us to process your personal information for the
                        purposes of (a) personalized advertising, (b) selling your personal information,
                        or (c) user profiling that has significant legal or similar implications for you.
                    </p>
                    <p>
                        As set forth in the VCDPA, CPA, and CDPA you have the right to exercise the above rights without discrimination.
                    </p>
                    <p>
                        You may exercise your rights to personal information as described above by contact
                        us at <a href="privacy@mobvista.com">privacy@mobvista.com</a>. If you fail to provide valid information for our
                        effective feedback, etc. when exercising your rights as described above, we may deny
                        your right to exercise your rights. If you have any dispute on such denial, you may
                        raise such dispute by contact us at <a href="privacy@mobvista.com">privacy@mobvista.com</a>.
                    </p>
                    <p>
                        For clarification, we do not sell your personal information or use your personal
                        information for targeted advertising or profiling.
                    </p>
                    <p>
                        If you are a resident of the mainland of the People's Republic of China, you have the
                        following rights related to your personal information except when laws and
                        administrative regulations otherwise provide.
                    </p>
                    <p>
                        (i)Right to be informed, right to decide and right to restrict or refuse processing of your personal information.
                    </p>
                    <p>
                        (ii)Right to access and copy your personal information except in special circumstance provided by law.
                    </p>
                    <p>
                        (iii)Right to request to transfer your personal information to another data handler.
                    </p>
                    <p>
                        (iv)Right to request to revise and supplement your personal information when you
                        notice that the personal information we process is inaccurate or incomplete.
                    </p>
                    <p>
                        (v)Request the deletion of your personal information under certain conditions,
                        such as (a) when the processing purpose has been fulfilled or is no longer
                        necessary; (b) when XMP ceases to provide services, or when the retention
                        period has expired; (c) you withdraw your consent; (d) if XMP violates
                        applicable laws or this Policy, or under other conditions specified by law. If
                        technical difficulties prevent deletion, XMP will cease processing except for
                        storage and necessary security measures;
                    </p>
                    <p>
                        (vi)Request an explanation of this Policy.
                    </p>
                    <p>
                        To exercise these rights, you may contact us at <a href="privacy@mobvista.com">privacy@mobvista.com</a>.
                    </p>
                    <p>
                        Once you withdraw your consent, we will no longer process your information.
                        However, your decision to withdraw your consent will not apply retroactively.
                    </p>
                    <p>&nbsp;</p>
                    <h4>
                        9. Security of User’s Personal Information
                        <span className="Apple-converted-space">&nbsp;</span>
                    </h4>
                    <p>
                        The security of User’s information is our utmost priority, and we take strict measures
                        in order to protect our data from unauthorized access, use, disclosure or destruction of
                        data. We have implemented physical, technical and administrative security measures
                        for the XMP Services that comply with applicable laws and industry standards. For
                        example, we use firewalls, encryption technology and other automated software
                        designed to protect against fraud and identity theft; our data is only stored in centers
                        that provide high-level security for User’s information. Physical access is strictly
                        controlled both at the perimeter and at building ingress points by our staff utilizing
                        video surveillance and other electronic means.
                    </p>
                    <p>
                        We also protect User’s privacy by seeking to minimize the amount of sensitive data
                        that we store on our servers in the first place. We also seek appropriate contractual
                        protection from our partners regarding their treatment of user data.
                    </p>
                    <p>
                        Generally, XMP will retain the information for one (1) year unless any applicable law
                        requires otherwise. The criteria used to determine the retention periods include: (i)
                        how long the personal data is needed to provide the services and operate the business;
                        (ii) the type of personal data collected; and (iii) whether we are subject to a legal,
                        contractual or similar obligation to retain the data (e.g., mandatory data retention laws,
                        government orders to preserve data relevant to an investigation, or data that must be
                        retained for the purposes of litigation or disputes).
                    </p>
                    <p>&nbsp;</p>
                    <h4>
                        10. Protection for Minors
                        <span className="Apple-converted-space">&nbsp;</span>
                    </h4>
                    <p>
                        We are committed to complying with the Children’s Online Privacy Protection Act
                        (COPPA) and any applicable laws relating to children. In addition, we do not
                        knowingly collect any personal information from children whom we know to be under
                        a certain age (as defined by applicable children's laws).
                    </p>
                    <p>
                        If a parent or guardian becomes aware that his or her child has provided us with
                        information without their consent, he or she should promptly contact us and we take
                        reasonable steps to ensure that such information is deleted from our files.
                    </p>
                    <p>&nbsp;</p>
                    <h4>
                        11. Marketing
                        <span className="Apple-converted-space">&nbsp;</span>
                    </h4>
                    <p>
                        We may contact you periodically by e-mail to provide information regarding our
                        products, services and content that may be of interest to you. If applicable law
                        requires that we receive your consent before we send you certain types of marketing
                        communications, we will only send you those types of communications after
                        receiving your consent.
                    </p>
                    <p>
                        If you decide at any time that you no longer wish to receive such communications
                        from us, you may follow the unsubscribe instructions provided in any of the
                        communications or request to be opted-out of receiving such communications via
                        email to <a href="privacy@mobvista.com">privacy@mobvista.com</a>.
                    </p>
                    <p>&nbsp;</p>
                    <h3>Privacy Policy of XMP Website</h3>
                    <p>&nbsp;</p>
                    <h4>1. Introduction</h4>
                    <p>
                        This Policy of XMP Website applies to information collection and use including
                        while you are visiting and using the XMP Sites. For the purposes of GDPR, XMP is
                        the Controller of your personal information.
                    </p>
                    <h4>2. What Information We Collect</h4>
                    <p>
                        As you navigate through this XMP Sites, some of your personal information may be
                        actively collected (for example, names, birth dates, personal ID card numbers,
                        addresses, telephone numbers, E-mail addresses, occupations, education, work
                        experience and related information), or passively collected (which you did not
                        actively provide) such as your browser type, domain name, IP address, pages visited,
                        and length of time that you spend browsing the website using various technologies
                        and means, such as Internet Protocol Address, cookies, Internet Tags and navigational
                        data collection. In order to improve our service quality, it may be necessary to ask for
                        personal information to fulfil your requests and provide a better service. XMP is
                        entitled to take measures to validate the authenticity of personal information you
                        provide. If you give us personal information of somebody else, you agree and warrant
                        that you have their permission to do so.
                    </p>
                    <h4>3. How We Use Your Information</h4>
                    <p>
                        The legal basis of our processing of your personal information is your consent.
                        The provision of personal information by you may be used for where in our legitimate
                        interest for the following purposes: (i) to provide you with XMP products or services
                        or information in relation to the same; (ii) to sign you up for an event or training; (iii)
                        send you marketing information about us or our affiliates; (iv) for business
                        administration, including statistical analysis; (v) to personalize your visit to the XMP
                        Sites and to assist you while you use the Site; or (vi) to improve the XMP Sites by
                        helping us understand who uses the Site.
                    </p>
                    <p>
                        We may also contact you periodically by e-mails to provide information regarding our
                        products, services and content that may be of interest to you. If applicable law
                        requires that we receive your consent before we send you certain types of marketing
                        communications, we will only send you those types of communications after
                        receiving your consent.
                    </p>
                    <p>
                        If you decide at any time that you no longer wish to receive such communications
                         from us, you may follow the unsubscribe instructions provided in any of the
                          communications or request to be opted-out of receiving such communications via
                           email to <a href="privacy@mobvista.com">privacy@mobvista.com</a>.
                    </p>
                    <h4>4. Disclosure of Your Personal Information</h4>
                    <p>
                        We may employ third parties to provide services to us and to assist in the hosting and
                        operation of the XMP Sites, including
                        <a href="https://xmp.mobvista.com/official/one-pager/Website+Technology+Service+Providers.pdf">
                        our cloud server provider</a>, web analytics provider (as detailed in our <a href="#Cookie-Policy">Cookie Policy</a> ),
                        and <a href="https://xmp.mobvista.com/official/one-pager/Third-party+Technology+Service+Providers.pdf">
                        email service provider</a>, and these third parties may have access to your personal information.
                        We may also share your personal information with our affiliates for the purposes set forth in this Policy.
                    </p>
                    <p>
                        We also employ a third-party business data service provider ("AroundDeal") to
                        provide us with corporate contact services for the purpose of sending marketing
                        messages to visitors to the Site. With your expressly authorized consent, we will
                        transmit your IP address, time of page visit, and link to the page visited to
                        AroundDeal, match the information through AroundDeal's database of business
                        contacts, and based on the matching results, AroundDeal may provide us with your
                        name, email, job title, location, company name, company industry, and Linkin
                        account number, and send you marketing messages on our behalf. Information about
                        AroundDeal and its privacy policy can be found
                        <a href="https://www.arounddeal.com/privacy-center/privacy-policy">here</a>.
                    </p>
                    <p>
                        If we believe that you intend or have abused or damaged the XMP Sites, we will
                        investigate and cooperate with relevant law enforcement authorities to protect our
                        legitimate rights and interests.
                    </p>
                    <p>
                       At the same time, we may share your personal information as required or permitted by
                        law to comply with a subpoena or similar legal process or government request, or
                        when we believe in good faith that disclosure is legally required or otherwise
                        necessary to protect our rights and property, or the rights, property or safety of others,
                        including to advisers, law enforcement agencies, judicial and regulatory authorities.
                        We may also transfer your personal information to a third party that acquires all or
                        part of our assets or shares, or that succeeds us in carrying on all or a part of our
                        business, whether by merger, acquisition, reorganization or otherwise.
                    </p>
                    <h4>5. International Transfers</h4>
                    <p>
                        When you are located in the mainland of China, we store your personal information
                        inside the mainland of China. Where it is necessary to provide your personal
                        information to recipient outside mainland of China, we will transfer your personal
                        information according to the requirement of any applicable data protection law.
                    </p>
                    <p>
                        When you are located in the European Economic Area (“EEA”), personal information
                        collected about you will be transferred to recipients in countries located outside the
                        EEA or can be remotely accessed in countries located outside the EEA, including in
                        countries which may not be decided by the European Commission that it provides an
                        adequate level of protection to personal information. We have followed requirements
                        as set out in applicable law to provide adequate protection to your personal data. To
                        the extent as required by applicable law, our business partners will obtain your valid
                        consent to the extent for us to transfer your personal information to recipients
                        including XMP’s affiliates and any other recipients as described in this Policy, which
                        are located outside the EEA. You are entitled to withdraw your consent at any time.
                    </p>

                    <p>
                        XMP has entered into EU standard contractual clauses (“Model Contracts”) for
                         intra-group transfers of personal information to its affiliates. You can request a copy
                        of these Model Contracts by submitting your request via email to
                        <a href="privacy@mobvista.com">privacy@mobvista.com</a>. For the transfer of Personal
                         Information to AroundDeal,XMP has entered into an EU Standard Contract Clause with AroundDeal
                        (" AroundDeal Standard Contract ") for the transfer of personal information to
                        AroundDeal. You can request a copy of your AroundDeal standard contract by
                        sending an email to <a href="privacy@mobvista.com">privacy@mobvista.com</a>.
                    </p>
                    <p>
                        When you are located in the mainland of China, we store your personal information
                        inside the mainland of China. Where it is necessary to provide your personal
                        information to recipient outside mainland of China, we will transfer your personal
                        information according to the requirement of any applicable data protection law. 
                    </p>
                    <h4>6. Your Data Rights</h4>
                    <p>
                        You have the right to access, modify, correct or delete any personal data which we
                        may have collected. To exercise your right, please contact us at
                        <a href="privacy@mobvista.com">privacy@mobvista.com</a>.
                    </p>
                    <p>
                        If you are in the EEA, you have a right to (subject to a limited number of exceptions
                         as permitted by GDPR):
                    </p>
                    <p>
                        (i)To request access to and rectification or erasure of your personal information;
                    </p>
                    <p>
                        (ii)To obtain restriction of processing or to object to processing of your personal information;
                    </p>
                    <p>
                        (iii)To ask for a copy of your personal information to be provided to them, or a third party, in a digital format.
                    </p>
                    <p>
                        You also have the right to lodge a complaint about the processing of your personal
                        information with your local data protection authority in the EEA.
                    </p>
                    <p>
                        If you are residents of the State of California in the United States, you can request the
                        following information about how we have collected and used your personal
                        information during the past 12 months:
                    </p>
                    <p>
                        (i)The categories of personal information we have collected.
                    </p>
                    <p>
                        (ii)The categories of sources from which we collected the personal information.
                    </p>
                    <p>
                        (iii)The business or commercial purpose for collecting, selling or sharing personal information.
                    </p>
                    <p>
                        (iv)The categories of third parties with whom we disclose the personal information.
                    </p>
                    <p>
                        (v)The categories of personal information that we sold, shared or disclosed for a business purpose.
                    </p>
                    <p>
                        (vi)The categories of third parties to whom the personal information was sold, shared or disclosed
                        for a business purpose.
                    </p>
                    <p>
                        (vii)Access. You can request a copy of your personal information that we have collected during the past 12 months.
                    </p>
                    <p>
                        (viii)You can ask us to delete your personal information that we have collected.
                    </p>
                    <p>
                        (ix)You can ask us to correct inaccuracies of your personal information.
                    </p>
                    <p>
                        You are entitled to exercise the rights described above free from discrimination as
                        prohibited by the CCPA. You may (i) submit requests to exercise your California
                        privacy rights described above by contact us at <a href="privacy@mobvista.com">privacy@mobvista.com</a> or send a
                        written document to the following address: Legal Department, Room 4312, No. 222-3
                        Xingmin Road, Tianhe District, Guangzhou City, Guangdong Province, China; (ii)
                        submit requests to restrict the use of your sensitive personal information by contact us
                        at <a href="privacy@mobvista.com">privacy@mobvista.com</a>. 
                    </p>
                    <p>
                        For clarification, we do not sell or share your personal information as defined by the CCPA.
                    </p>
                    <p>
                        If you are a resident of the State of Virginia in the United States, effective January 1,
                         2023, or if you are a resident of the State of Colorado or Connecticut in the United
                          States, effective July 1, 2023, you may exercise the following personal information rights with us.
                    </p>
                    <p>
                        (i)To confirm whether we are processing your personal information and to access that personal information;
                    </p>
                    <p>
                        (ii)To correct any inaccuracies in your personal information;
                    </p>
                    <p>
                        (iii)To delete your personal information;
                    </p>
                    <p>
                        (iv)To obtain a copy of the personal information you have provided to us; and
                    </p>
                    <p>
                        (v)To request a refusal to allow us to process your personal information for the
                        purposes of (a) personalized advertising, (b) selling your personal information,
                        or (c) user profiling that has significant legal or similar implications for you.
                    </p>
                    <p>
                        As set forth in the VCDPA, CPA, and CDPA you have the right to exercise the above
                         rights without discrimination.
                    </p>
                    <p>
                        You may exercise your rights to personal information as described above by contact us at
                        <a href="privacy@mobvista.com">privacy@mobvista.com</a>. If you fail to provide valid information
                        for our effective feedback, etc. when exercising your rights as described above, we may deny your
                        right to exercise your rights. If you have any dispute on such denial, you may raise such dispute
                        by contact us at <a href="privacy@mobvista.com">privacy@mobvista.com</a>.
                    </p>
                    <p>
                        For clarification, we do not sell your personal information or use your personal
                        information for targeted advertising or profiling.
                    </p>
                    <p>
                        If you are a resident of the mainland of the People's Republic of China, you have the
                        following rights related to your personal information except when laws and
                        administrative regulations otherwise provide.
                    </p>
                    <p>
                        (i)Right to be informed, right to decide and right to restrict or refuse processing
                        of your personal information.
                    </p>
                    <p>
                        (ii)Right to access and copy your personal information except in special circumstance provided by law.
                    </p>
                    <p>
                        (iii)Right to request to transfer your personal information to another data handler.
                    </p>
                    <p>
                        (iv)Right to request to revise and supplement your personal information when you
                        notice that the personal information we process is inaccurate or incomplete.
                    </p>
                    <p>
                        (v)Request the deletion of your personal information under certain conditions,
                        such as (a) when the processing purpose has been fulfilled or is no longer
                        necessary; (b) when XMP ceases to provide services, or when the retention
                        period has expired; (c) you withdraw your consent; (d) if XMP violates
                        applicable laws or this Policy, or under other conditions specified by law. If
                        technical difficulties prevent deletion, XMP will cease processing except for
                        storage and necessary security measures;
                    </p>
                    <p>
                        (vi)Request an explanation of this Policy.
                    </p>
                    <p>
                        To exercise these rights, you may contact us at <a href="privacy@mobvista.com">privacy@mobvista.com</a>.
                    </p>
                    <h4>7. Security of Your Personal Information</h4>
                    <p>
                        We are committed to protecting the security of your personal information. We use a
                        variety of security technologies and procedures to help protect your personal
                        information from unauthorized access, use, or disclosure. We will only keep your
                        personal information for as long as necessary and in any event in relation to personal
                        information collected by us on the Site we will only keep this personal information for
                        one (1) year.
                    </p>
                    <h4>
                        8. The Protection of Minors
                    </h4>
                    <p>
                        The Site does not knowingly collect any personal information from minors. The
                        personal information of any minor you provide shall be agreed by the minor’s parent
                        or guardian in advance. Minor is defined in accordance with the laws applicable to
                        this Policy.
                    </p>
                    <h4>
                        9. Use of Cookies and Other Tracking Technologies
                    </h4>
                    <p>
                        XMP may use cookies or other technology (collectively “Cookies”) to collect certain
                        information about you when you are visiting the Site. Please read our <a href="#Cookie-Policy">
                        Cookies Policy</a> for more details.
                    </p>
                    <h4>10. Outside Sites and Linking</h4>
                    <p>
                        The Site may contain links and pointers to other sites on the Internet that are owned or
                        operated by third party vendors and other third parties (the “Outside Sites“).
                        XMP is not responsible for the availability of, or the content located on or through,
                        any Outside Sites, including any webcasting or other form of transmission received from
                        any Outside Sites. You should contact the site administrator or webmaster for those
                        Outside Sites if you have any concerns regarding such links or the content located on
                        such Outside Sites. XMP permits certain third party links to the home page of its Site,
                        provided that XMP is provided with notice of such links and does not thereafter object
                        to such linking. XMP reserves the right to revoke unilaterally any consent that it may
                        at any time give to any linkage, including linkages to the home page. The Outside Sites
                        are being provided to you only as a convenience and any link or pointer contained on the
                        Site does not imply endorsement of the Outside Sites.
                    </p>
                    <h4>
                        11. Copyright
                    </h4>
                    <p>
                        All Site content, design, text, graphics, images, logos, buttons, icons, interfaces, audio
                        and video clips, and the selection and arrangements thereof are the exclusive property
                        of XMP, or its respective content providers, and are protected by Hong Kong SAR
                        and international copyright laws. All software used on the Site are the property of
                        XMP or its respective software suppliers, and such software is protected by Hong Kong
                        SAR and international copyright laws and other applicable laws and treaties. Users of
                        the Site shall not transmit/post any information to the Site that infringes the copyright
                        or other intellectual property rights of others.
                    </p>
                    <h4>
                        12. Trademarks
                    </h4>
                    <p>
                        All trademarks, service marks and trade names used on the Site (collectively the “Marks”)
                        are solely owned by XMP. The Marks may not be used in connection with any product or service
                        that is not a product or service of XMP or that is likely to cause confusion among customers,
                        or that in any manner disparages or discredits XMP.
                    </p>
                    <h4>13. Online Conduct</h4>
                    <p>
                        Any conduct by a person that in XMP ‘s sole discretion restricts or inhibits any other person
                        from using or enjoying the Site, is prohibited. You agree to use the Site only for lawful
                        purposes and in accordance with that prohibition. You agree that you will not post on the
                        Site or transmit any unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar,
                        obscene, sexually explicit, profane, hateful, racially, ethnically, or otherwise objectionable
                        material of any kind, including, but not limited to, any material that encourages conduct that
                        would constitute a criminal offense, give rise to civil liability or otherwise violate any
                        applicable local, state, national, or international law.
                    </p>
                    <h4>
                      14. Termination of Usage
                    </h4>
                    <p>
                        XMP may, without incurring any liability to you, terminate access by you or suspend
                        any access to all or part of the Site, without notice, for any conduct that XMP, in its
                        sole discretion, believes is in violation of any applicable law or this Agreement, or is
                        harmful to the interests of another user, a third-party, a merchant, a sponsor, a licensor,
                        a service provider, or the Site.<br/>
                        Due to the rapidly evolving technologies on the internet, we may occasionally update
                        this Policy. All revisions will be posted to this website
                        <a href="https://xmp.mobvista.com/en">https://xmp.mobvista.com/en</a>.
                    </p>
                    <h4 id="Cookie-Policy">XMP Cookies Policy</h4>
                    <p>（略）</p>
                </div>
            </div>
        </div>
    );
}

export default PrivateEN;